// extracted by mini-css-extract-plugin
export default {"buttonSocial":"ButtonSocial_buttonSocial__A24OY","iconChat":"ButtonSocial_iconChat__0lKtP"};